import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser } from "@fortawesome/free-solid-svg-icons";

export default function UserBadge( { isLoggedIn, name, accountType } ) {
  let displayText = "Not logged in";

  if (isLoggedIn) {
    displayText = accountType === "CONTACT_ONLY" ? "Temporary" : name;
  }

  return (
    <>
      <style>{`
        .user-badge {
          display: inline-flex;
          align-items: center;
          gap: clamp(1px, 2vw, 10px);

          background-color: #ffffff;

          padding: clamp(2px, 3vw, 20px) clamp(1px, 3vw, 25px);
          box-shadow: 0 8px 28px rgba(0, 0, 0, 0.05);

          border-radius: 10px;

          font-size: clamp(11px, 1vw, 20px);
          font-weight: 500;
          color: #000;
          z-index: 1;
        }

        .user-icon {
          font-size: clamp(21px, 4vw, 25px);
          color: #000;
        }

        .user-name {
          color: #000;
          font-size: clamp(11px, 1vw, 20px);
          max-width: 20vw;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

      `}</style>

      <div className="user-badge">
        <FontAwesomeIcon icon={faCircleUser} className="user-icon" />
        <span className="user-name">{displayText}</span>
      </div>
    </>
  );
}
